import { combineReducers } from "redux";
import user from "./user";
import theme from "./theme";
import language from "./language";
import bestPriceCoins from "./bestPriceCoins";
import tokenStore from "./tokenStore";
const rootReducers = combineReducers({
  user,
  theme,
  language,
  bestPriceCoins,
  tokenStore,
});

export default rootReducers;
